import "@/Scss/main.scss";

import "virtual-livereload";

import * as $ from "jquery";

import { addMobileLabels } from "./table";
import { activateMenu } from "./menu";
import { activateAnimations } from "./animations";
import { activateContrastButton } from "./contrast";
import { evalNavigation } from "./account";
import { flipBox } from './flipbox';
import { activateSlider } from "./slider";
import { activateTextmediaChevron } from "./textmedia";
import { activateFooter } from "./footer";
import { activateVideo } from "./videoControl";
import { activateMasonry } from "./bloglist";
import { activate1Question } from "./1question";
import { anchorHelper } from "./anchorHelper";
import { activateCopyright } from "./copyright";
import { activateHomepageSlider } from "./homepage-slider";
import { activateAdjustContainerHeight } from "./adjustContainerHeight.ts";
import { activateTeaserEqualHeight } from "./teaserEqualHeight.ts";
import { activateCookiebanner } from "./cookiebanner.ts";


declare global {
  interface Window {
    disableAnimations: any;
    loadMapContent: any;
    $markers: object;
    showPin: any;
    $: JQuery;
  }
}

window.$ = $();

window.disableAnimations = () => {
  $.fx.off = true;
};

// global functions
document.addEventListener("DOMContentLoaded", function (event) {
  // make main menu clickable
  activateContrastButton();
  activateMenu();
  activateAnimations();
  activateTextmediaChevron();
  evalNavigation();
  flipBox();
  activateFooter();
  activateVideo();
  anchorHelper();
  addMobileLabels();
  activateCopyright();
  activateAdjustContainerHeight();
  activateTeaserEqualHeight();
  activateCookiebanner();

  // Back-to-list Event Listener
  document.querySelectorAll('[data-action="back-to-list"]').forEach(function (el) {
    el.addEventListener('click', function (e) {
      e.preventDefault();
      history.back();
    });
  });
});

window.addEventListener("load", function () {
  activateSlider();
  activateMasonry();
  activate1Question();
  activateHomepageSlider();
});

// TYPO3 core JS functions
// normally needed in all installations, do NOT remove
// decrypt helper function
function decryptCharcode(n, start, end, offset) {
  n = n + offset;
  if (offset > 0 && n > end) {
    n = start + (n - end - 1);
  } else if (offset < 0 && n < start) {
    n = end - (start - n - 1);
  }
  return String.fromCharCode(n);
}

// decrypt string
function decryptString(enc, offset) {
  var dec = "";
  var len = enc.length;
  for (var i = 0; i < len; i++) {
    var n = enc.charCodeAt(i);
    if (n >= 0x2b && n <= 0x3a) {
      dec += decryptCharcode(n, 0x2b, 0x3a, offset); // 0-9 . , - + / :
    } else if (n >= 0x40 && n <= 0x5a) {
      dec += decryptCharcode(n, 0x40, 0x5a, offset); // A-Z @
    } else if (n >= 0x61 && n <= 0x7a) {
      dec += decryptCharcode(n, 0x61, 0x7a, offset); // a-z
    } else {
      dec += enc.charAt(i);
    }
  }
  return dec;
}

// decrypt spam-protected emails
function linkTo_UnCryptMailto(s) {
  location.href = decryptString(s, 3);
}
